import moment from 'moment'
import { TEN_DAYS_BEFORE_CHECK_IN } from 'constants/cancellationPolicies'

export interface CashRefundCancellationTimelineDetails {
  today: moment.Moment
  checkInDate?: string | moment.Moment
  /** Last day a cancellation refunds to the original payment method, in the property's offset. */
  deadline?: moment.Moment
  days: number
  numberOfDateChangesAllowed?: string
}

interface CashRefundCancellationTimelineDetailsParams {
  checkInDate?: string | moment.Moment
  propertyTimezoneOffset?: number
  today?: moment.Moment
  numberOfDateChangesAllowed?: string
}

function hasPropertyTimezoneOffset(propertyTimezoneOffset: number | undefined) {
  return propertyTimezoneOffset !== undefined
}

export function getCashRefundCancellationTimelineDetails(
  params: CashRefundCancellationTimelineDetailsParams,
): CashRefundCancellationTimelineDetails {
  const { checkInDate, propertyTimezoneOffset, today, numberOfDateChangesAllowed } = params
  const timelineToday = today ?? (hasPropertyTimezoneOffset(propertyTimezoneOffset) ? moment().utcOffset(propertyTimezoneOffset) : moment())
  const checkInMoment = checkInDate ? moment(checkInDate) : undefined
  const deadline = checkInMoment && (hasPropertyTimezoneOffset(propertyTimezoneOffset)
    ? checkInMoment.utcOffset(propertyTimezoneOffset, true)
    : checkInMoment
  ).subtract(TEN_DAYS_BEFORE_CHECK_IN, 'days')

  return {
    today: timelineToday,
    checkInDate,
    deadline,
    days: TEN_DAYS_BEFORE_CHECK_IN,
    numberOfDateChangesAllowed,
  }
}
